import { useAuthMutations  } from '@/modules/authentication/contracts';
import type { RegisterDto } from '@/modules/authentication/contracts';

import { Result } from '@packages/domain-driven';

export const useRegistration = () => {
	const { registerMutation } = useAuthMutations();

	const submit = async (dto: RegisterDto) => {
		try {
			await registerMutation.mutateAsync(dto);

			return Result.ok();
		}
		catch (error: unknown) {
			if (error instanceof Error && error.message.includes('409')) {
				return Result.fail('This email is already registered. Please log in instead.');
			}
			else {
				return Result.fail('This registration could not be completed. Please try again later.');
			}
		}
	};

	return {
		submit,
		...registerMutation,
	};
};
